import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_67hq8tqqfa: FaireBrandEntity = {
  token: "b_67hq8tqqfa",
  type: "brand",
  name: "HARIO USA",
  avatarUrl:
    "https://cdn.faire.com/fastly/c7193ad91bb87030b1a9f04dbeaa5665314787fdbea105ae23ed9344c3bc800e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2e16c5de0658e68acaa2267dd22b1cfbda41d23df58432c0d04874ad60cc0acc.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c7193ad91bb87030b1a9f04dbeaa5665314787fdbea105ae23ed9344c3bc800e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2e16c5de0658e68acaa2267dd22b1cfbda41d23df58432c0d04874ad60cc0acc.jpeg",
  location: "El Segundo, CA, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 20,
  isTopShop: true,
  isInsider: true,
  description:
    "For over 100 years, we have been making products that customers cherish.\n\nHARIO has been planning, manufacturing and selling heatproof glass since its very inception (1921) — and is the only manufacturer with a heatproof glass factory in Japan.\n\nInitially, we manufactured and sold laboratory glassware. But in 1948, we began making coffee siphons by taking advantage of the properties of heatproof glass and our refined glass processing techniques.\n\nWe later expanded into a wide range of popular home products made from various materials. Since the 1980s, we’ve been producing industrial glass for automotive light lenses. We also offer items for coffee and tea (black, Japanese and herbal), as well as microwave-safe cooking utensils and other kitchenware.\n\nIn the next 100 years, we want to continue enhancing the lives of everyone who loves HARIO and keep creating products that people consider their favorites.",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:28:23.291Z",
    importedBy: "entity-db-cli",
  },
};
